import { isAxiosError } from "axios"
import { TIndicationBody, TIndicationPageable, TIndicationRegister, TIndicationUpdate } from "core/models/indication"
import { IPage, IResponseBody } from "core/models/utils"
import { axiosInstance } from "../axios/axiosInstance"
import {INDICATION_LIST, INDICATION_SAVE, INDICATION_TYPE_LIST, INDICATION_UPDATE} from "core/utils/constants"
import { Notification } from "app/components/toastNotification/toastNotification"

const getIndicationsType = async (): Promise<any> => {
    try {
        const response = await axiosInstance.get<any>(INDICATION_TYPE_LIST)
        return response.data.data
    }
    catch (error) {
        console.error(error)
        return error
    }
}

const getFiltedIndication = async (
    indicationPageable: TIndicationPageable
): Promise<IPage<TIndicationBody | undefined>> => {
    const response = await axiosInstance.get<IResponseBody<IPage<TIndicationBody>>>(
        INDICATION_LIST,
        {
            params: {
                page: indicationPageable.page,
                size: indicationPageable.size,
                sort: "name,desc",
                name: indicationPageable?.name,
            },
        }
    )
    return response.data.data
}

const updateIndication = async (updatedIndication: TIndicationUpdate, idIndication: string): Promise<any> => {
    return await axiosInstance
        .put(`${INDICATION_UPDATE}${idIndication}`, updatedIndication)
        .then((resp) => {
            Notification(resp.data.data, 'success')
            return resp
        }).catch((error) => {
            Notification(String(error.message), 'error')
            return error
        })
}

const createIndication = async (
    newIndication: TIndicationRegister
): Promise<any> => {
    return await axiosInstance
        .post(`${INDICATION_SAVE}`, newIndication)
        .then((response) => {
            if (response instanceof isAxiosError) {
                return response.data.errors;
            }
            Notification(response.data.data, 'success')
            return response;
        });
};

export const IndicationService = {
    getFiltedIndication,
    updateIndication,
    createIndication,
    getIndicationsType
}
